<template>
  <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
            <div class="d-flex justify-end">
        <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
         >
        <v-icon left>mdi-youtube</v-icon>
        Watch Tutorial
        </v-btn>
</div>
      <v-card class="box" v-if="ay_std_div_list != null">
          <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                  <strong> Lesson Planning </strong>
              </v-toolbar-title>
          </v-toolbar>
          <v-row justify="center" dense>
              <v-col sm="1"> </v-col>
              <v-col sm="3">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete
                      color="#0F2027"
                      dense
                      rounded
                      required
                      v-model="sel_ay_data"
                      return-object
                      :items="ay_std_div_list"
                      item-text="ay"
                      label="Select Academic Year"
                      outlined
                      @change="getStd()"
                      persistent-hint
                      hint="Please Select Academic Year"
                  />
              </v-col>
              <v-col sm="3" v-if="std_div_list != null">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete
                      color="#0F2027"
                      dense
                      rounded
                      required
                      v-model="sel_std_data"
                      return-object
                      :items="std_div_list"
                      item-text="std"
                      label="Standard"
                      outlined
                      @change="getCourse"
                      persistent-hint
                      hint="Please Select Standard"
                  />
              </v-col>
              <v-col sm="3" v-if="crs_list != null">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="crs" item-value="crs_id" :items="crs_list" item-text="crs_name" label="Subject" outlined persistent-hint hint="Please Select Subject" />
              </v-col>
              <v-col sm="2" v-if="crs != null">
                  <v-btn class="mt-6 button" @click="getLessonPlan">Proceed</v-btn>
              </v-col>
          </v-row>
          <v-card flat v-if="add_new == true">
              <v-row dense justify="center">
                  <v-col class="v-col" sm="2">
                      <v-text-field v-model="lesson_no_edit" readonly color="#0F2027" rounded dense label="Lesson No." placeholder="Lesson No." outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                      <v-text-field v-model="unit" color="#0F2027" rounded dense label="Chapter" placeholder="Chapter" outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                      <v-text-field v-model="topic" color="#0F2027" rounded dense label="Concept Skill / Topic" placeholder="Concept Skill / Topic" outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                      <v-text-field v-model="outcome" color="#0F2027" rounded dense label="Learning Outcomes" placeholder="Learning Outcomes" outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                      <v-text-field v-model="tools" color="#0F2027" rounded dense label="Instructional Tools & References" placeholder="Instructional Tools & References" outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                      <v-text-field v-model="pedagogy" color="#0F2027" rounded dense label="Pedagogy" placeholder="Pedagogy" outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                      <v-text-field v-model="assignment" color="#0F2027" rounded dense label="Activity / Assignment / Research" placeholder="Activity / Assignment / Research" outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                      <v-text-field v-model="assessment" color="#0F2027" rounded dense label="Assessment" placeholder="Assessment" outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                      <v-text-field v-model="exammination" color="#0F2027" rounded dense label="Examination" placeholder="Examination" outlined></v-text-field>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="2">
                      <v-btn class="button" @click="saveLessonPlan"><v-icon>mdi-plus</v-icon>Add</v-btn>
                  </v-col>
              </v-row>
          </v-card>

          <!-- Edit Lesson Plan Start-->
          <!-- Edit unit-->

          <v-card flat v-if="edit_new == true">
              <v-col cols="12" lg="9" sm="12">
                  <v-row dense justify="center">
                      <v-row>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Lesson No :: </strong></span>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field v-model="lesson_no_edit" color="#0F2027" rounded dense label="Lesson No" placeholder="Lesson No" outlined></v-text-field>
                          </v-col>
                          <!-- <v-col class="p-none" cols="2" lg="2" sm="2">
               <v-btn small color="primary" @click="updateLessonNo()" title="Update">Update Lesson No</v-btn>
             </v-col> -->
                      </v-row>
                  </v-row>

                  <v-row dense justify="center">
                      <v-row>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Chapter :: </strong></span>
                          </v-col>
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      x-small
                                      fab
                                      outlined
                                      icon
                                      color="#0F2027"
                                      class="mr-2 mt-4"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                    addnewlessonplan.type = 'unit';
                    dialog_add_new = true;
                  "
                                  >
                                      <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                              </template>
                              <span> Add new chapter!!! </span>
                          </v-tooltip>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field :readonly="!unit_flag" v-model="edit_unit" color="#0F2027" rounded dense label="Chapter" placeholder="Chapter" outlined></v-text-field>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="2" sm="2">
                              <v-btn
                                  v-if="edit_unit"
                                  class="button"
                                  x-small
                                  @click="
                  save_edit_item(
                    edit_course_plan_id,
                    edit_unit,
                    unit_index,
                    (type = 'unit')
                  )
                "
                              >
                                  <v-icon>mdi-plus</v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-row>
                  <v-row dense justify="center" v-for="(unit, index) in unit_list" :key="index">
                      <v-col sm="5">
                          <v-row dense>
                              <v-btn
                                  x-small
                                  fab
                                  icon
                                  outlined
                                  @click="
                  editunit(unit.unit, index, (type = 'unit'));
                  unit_flag = true;
                "
                                  color="#0F2027"
                              >
                                  <v-icon x-small color="#0F2027" title="edit">edit</v-icon>
                              </v-btn>
                              <v-btn
                                  x-small
                                  fab
                                  outlined
                                  icon
                                  color="error"
                                  @click="
                  deletelistvalue(index, (type = 'unit'), edit_course_plan_id)
                "
                                  class="btn1"
                              >
                                  <v-icon x-small color="error" title="delete">delete</v-icon>
                              </v-btn>
                              <span class="ml-4 pt-1">{{ index + 1 }}.{{ unit.unit }}</span>
                          </v-row>
                      </v-col>
                  </v-row>

                  <!-- <v-row dense justify="center">
                  Concept Skill / Topic
              </v-row> -->
                  <v-row class="pt-2" dense justify="center">
                      <v-row>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Concept Skill / Topic :: </strong></span>
                          </v-col>
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      x-small
                                      fab
                                      outlined
                                      icon
                                      color="#0F2027"
                                      class="mr-2 mt-4"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                    addnewlessonplan.type = 'topic';
                    dialog_add_new = true;
                  "
                                  >
                                      <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                              </template>
                              <span> Add new concept skill / topic !!! </span>
                          </v-tooltip>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field :readonly="!topic_flag" v-model="edit_topic" color="#0F2027" rounded dense label="Concept Skill / Topic" placeholder="Concept Skill / Topic" outlined></v-text-field>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="2" sm="2">
                              <v-btn v-if="edit_topic != null" class="button" x-small>
                                  <v-icon
                                      @click="
                    save_edit_item(
                      edit_course_plan_id,
                      edit_topic,
                      topic_index,
                      (type = 'topic')
                    )
                  "
                                  >
                                      mdi-plus
                                  </v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-row>
                  <v-row dense justify="center" v-for="(topic, index) in topic_list" :key="index">
                      <v-col sm="5">
                          <v-row dense>
                              <v-btn
                                  x-small
                                  fab
                                  icon
                                  outlined
                                  @click="
                  editunit(topic.topic, index, (type = 'topic'));
                  topic_flag = true;
                "
                                  color="#0F2027"
                              >
                                  <v-icon x-small color="#0F2027" title="edit">edit</v-icon>
                              </v-btn>
                              <v-btn
                                  x-small
                                  fab
                                  outlined
                                  icon
                                  color="error"
                                  @click="
                  deletelistvalue(
                    index,
                    (type = 'topic'),
                    edit_course_plan_id
                  )
                "
                                  class="btn1"
                              >
                                  <v-icon x-small color="error" title="delete">delete</v-icon>
                              </v-btn>
                              <span class="ml-4 pt-1">{{ index + 1 }}.{{ topic.topic }}</span>
                          </v-row>
                      </v-col>
                  </v-row>
                  <!-- <v-row dense justify="center">
                  Learning Outcomes
              </v-row> -->
                  <v-row class="pt-2" dense justify="center">
                      <v-row dense>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Learning Outcomes :: </strong></span>
                          </v-col>
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      x-small
                                      fab
                                      outlined
                                      icon
                                      color="#0F2027"
                                      class="mr-2 mt-3"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                    addnewlessonplan.type = 'outcome';
                    dialog_add_new = true;
                  "
                                  >
                                      <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                              </template>
                              <span> Add new learning outcomes !!! </span>
                          </v-tooltip>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field :readonly="!outcome_flag" v-model="edit_outcome" color="#0F2027" rounded dense label="Learning Outcomes" placeholder="Learning Outcomes" outlined></v-text-field>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="2" sm="2">
                              <v-btn
                                  v-if="edit_outcome != null"
                                  class="button"
                                  x-small
                                  @click="
                  save_edit_item(
                    edit_course_plan_id,
                    edit_outcome,
                    outcome_index,
                    (type = 'outcome')
                  )
                "
                              >
                                  <v-icon>mdi-plus</v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-row>
                  <v-row dense justify="center" v-for="(outcome, index) in outcome_list" :key="index">
                      <v-col sm="5">
                          <v-row dense>
                              <v-btn
                                  x-small
                                  fab
                                  icon
                                  outlined
                                  @click="
                  editunit(outcome.outcome, index, (type = 'outcome'));
                  outcome_flag = true;
                "
                                  color="#0F2027"
                              >
                                  <v-icon x-small color="#0F2027" title="edit">edit</v-icon>
                              </v-btn>
                              <v-btn
                                  x-small
                                  fab
                                  outlined
                                  icon
                                  color="error"
                                  @click="
                  deletelistvalue(
                    index,
                    (type = 'outcome'),
                    edit_course_plan_id
                  )
                "
                                  class="btn1"
                              >
                                  <v-icon x-small color="error" title="delete">delete</v-icon>
                              </v-btn>
                              <span class="ml-4 pt-1">{{ index + 1 }}.{{ outcome.outcome }}</span>
                          </v-row>
                      </v-col>
                  </v-row>
                  <!-- <v-row dense justify="center">
                  Instructional Tools & References
              </v-row> -->
                  <v-row class="pt-2" dense justify="center">
                      <v-row dense>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Instructional Tools & References :: </strong></span>
                          </v-col>
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      x-small
                                      fab
                                      outlined
                                      icon
                                      color="#0F2027"
                                      class="mr-2 mt-3"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                    addnewlessonplan.type = 'tool';
                    dialog_add_new = true;
                  "
                                  >
                                      <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                              </template>
                              <span> Add new instructional tools & references !!! </span>
                          </v-tooltip>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field :readonly="!tool_flag" v-model="edit_tool" color="#0F2027" rounded dense label="Instructional Tools & References" placeholder="Instructional Tools & References" outlined></v-text-field>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="2" sm="2">
                              <v-btn
                                  v-if="edit_tool != null"
                                  class="button"
                                  x-small
                                  @click="
                  save_edit_item(
                    edit_course_plan_id,
                    edit_tool,
                    tool_index,
                    (type = 'tool')
                  )
                "
                              >
                                  <v-icon>mdi-plus</v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-row>
                  <v-row dense justify="center" v-for="(tool, index) in tool_list" :key="index">
                      <v-col sm="5">
                          <v-row dense>
                              <v-btn
                                  x-small
                                  fab
                                  icon
                                  outlined
                                  color="#0F2027"
                                  @click="
                  editunit(tool.tool, index, (type = 'tool'));
                  tool_flag = true;
                "
                              >
                                  <v-icon x-small color="#0F2027" title="edit">edit</v-icon>
                              </v-btn>
                              <v-btn
                                  x-small
                                  fab
                                  outlined
                                  icon
                                  color="error"
                                  @click="
                  deletelistvalue(index, (type = 'tool'), edit_course_plan_id)
                "
                                  class="btn1"
                              >
                                  <v-icon x-small color="error" title="delete">delete</v-icon>
                              </v-btn>
                              <span class="ml-4 pt-1">{{ index + 1 }}.{{ tool.tool }}</span>
                          </v-row>
                      </v-col>
                  </v-row>
                  <!-- <v-row dense justify="center">
                  Pedagogy
              </v-row> -->
                  <v-row class="pt-2" dense justify="center">
                      <v-row dense>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Pedagogy :: </strong></span>
                          </v-col>
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      x-small
                                      fab
                                      outlined
                                      icon
                                      color="#0F2027"
                                      class="mr-2 mt-3"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                    addnewlessonplan.type = 'pedagogy';
                    dialog_add_new = true;
                  "
                                  >
                                      <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                              </template>
                              <span> Add new pedagogy !!! </span>
                          </v-tooltip>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field v-model="edit_pedagogy" color="#0F2027" rounded dense label="Pedagogy" :readonly="!pedagogy_flag" placeholder="Pedagogy" outlined></v-text-field>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="2" sm="2">
                              <v-btn
                                  v-if="edit_pedagogy != null"
                                  class="button"
                                  x-small
                                  @click="
                  save_edit_item(
                    edit_course_plan_id,
                    edit_pedagogy,
                    pedagogy_index,
                    (type = 'pedagogy')
                  )
                "
                              >
                                  <v-icon>mdi-plus</v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-row>
                  <v-row dense justify="center" v-for="(pedagogy, index) in pedagogy_list" :key="index">
                      <v-col sm="5">
                          <v-row dense>
                              <v-btn
                                  x-small
                                  fab
                                  icon
                                  outlined
                                  @click="
                  editunit(pedagogy.pedagogy, index, (type = 'pedagogy'));
                  pedagogy_flag = true;
                "
                                  color="#0F2027"
                              >
                                  <v-icon x-small color="#0F2027" title="edit">edit</v-icon>
                              </v-btn>
                              <v-btn
                                  x-small
                                  fab
                                  outlined
                                  icon
                                  color="error"
                                  @click="
                  deletelistvalue(
                    index,
                    (type = 'pedagogy'),
                    edit_course_plan_id
                  )
                "
                                  class="btn1"
                              >
                                  <v-icon x-small color="error" title="delete">delete</v-icon>
                              </v-btn>
                              <span class="ml-4 pt-1">{{ index + 1 }}.{{ pedagogy.pedagogy }}</span>
                          </v-row>
                      </v-col>
                  </v-row>
                  <!-- <v-row dense justify="center">
                  Activity / Assignment / Research
              </v-row> -->
                  <v-row class="pt-2" dense justify="center">
                      <v-row dense>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Activity / Assignment / Research ::</strong></span>
                          </v-col>
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      x-small
                                      fab
                                      outlined
                                      icon
                                      color="#0F2027"
                                      class="mr-2 mt-3"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                    addnewlessonplan.type = 'assignment';
                    dialog_add_new = true;
                  "
                                  >
                                      <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                              </template>
                              <span> Add new activity / assignment / aesearch !!! </span>
                          </v-tooltip>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field
                                  :readonly="!assignment_flag"
                                  v-model="edit_assignment"
                                  color="#0F2027"
                                  rounded
                                  dense
                                  label="Activity / Assignment / Research"
                                  placeholder="Activity / Assignment / Research"
                                  outlined
                              ></v-text-field>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="2" sm="2">
                              <v-btn
                                  v-if="edit_assignment != null"
                                  class="button"
                                  x-small
                                  @click="
                  save_edit_item(
                    edit_course_plan_id,
                    edit_assignment,
                    assignment_index,
                    (type = 'assignment')
                  )
                "
                              >
                                  <v-icon>mdi-plus</v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-row>
                  <v-row dense justify="center" v-for="(assignment, index) in assignment_list" :key="index">
                      <v-col sm="5">
                          <v-row dense>
                              <v-btn
                                  x-small
                                  fab
                                  icon
                                  outlined
                                  color="#0F2027"
                                  @click="
                  editunit(
                    assignment.assignment,
                    index,
                    (type = 'assignment')
                  );
                  assignment_flag = true;
                "
                              >
                                  <v-icon x-small color="#0F2027" title="edit">edit</v-icon>
                              </v-btn>
                              <v-btn
                                  x-small
                                  fab
                                  outlined
                                  icon
                                  color="error"
                                  @click="
                  deletelistvalue(
                    index,
                    (type = 'assignment'),
                    edit_course_plan_id
                  )
                "
                                  class="btn1"
                              >
                                  <v-icon x-small color="error" title="delete">delete</v-icon>
                              </v-btn>
                              <span class="ml-4 pt-1">{{ index + 1 }}.{{ assignment.assignment }}</span>
                          </v-row>
                      </v-col>
                  </v-row>
                  <!-- <v-row dense justify="center">
                  Assessment
              </v-row> -->
                  <v-row class="pt-2" dense justify="center">
                      <v-row dense>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Assessment ::</strong></span>
                          </v-col>
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      x-small
                                      fab
                                      outlined
                                      icon
                                      color="#0F2027"
                                      class="mr-2 mt-3"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                    addnewlessonplan.type = 'assessment';
                    dialog_add_new = true;
                  "
                                  >
                                      <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                              </template>
                              <span> Add new assessment !!! </span>
                          </v-tooltip>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field v-model="assessment_edit" :readonly="!aassessment_flag" color="#0F2027" rounded dense label="Assessment" placeholder="Assessment" outlined></v-text-field>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="2" sm="2">
                              <v-btn
                                  v-if="assessment_edit != null"
                                  class="button"
                                  x-small
                                  @click="
                  save_edit_item(
                    edit_course_plan_id,
                    assessment_edit,
                    aassessment_index,
                    (type = 'assessment')
                  )
                "
                              >
                                  <v-icon>mdi-plus</v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-row>
                  <v-row dense justify="center" v-for="(assessment, index) in assessment_list" :key="index">
                      <v-col sm="5">
                          <v-row dense>
                              <v-btn
                                  x-small
                                  fab
                                  icon
                                  outlined
                                  color="#0F2027"
                                  @click="
                  editunit(
                    assessment.assessment,
                    index,
                    (type = 'assessment')
                  );
                  aassessment_flag = true;
                "
                              >
                                  <v-icon x-small color="#0F2027" title="edit">edit</v-icon>
                              </v-btn>
                              <v-btn
                                  x-small
                                  fab
                                  outlined
                                  icon
                                  color="error"
                                  class="btn1"
                                  @click="
                  deletelistvalue(
                    index,
                    (type = 'assessment'),
                    edit_course_plan_id
                  )
                "
                              >
                                  <v-icon x-small color="error" title="delete">delete</v-icon>
                              </v-btn>
                              <span class="ml-4 pt-1">{{ index + 1 }}.{{ assessment.assessment }}</span>
                          </v-row>
                      </v-col>
                  </v-row>
                  <!-- <v-row dense justify="center">
                  Examination
              </v-row> -->
                  <v-row class="pt-2" dense justify="center">
                      <v-row dense>
                          <v-col class="p-0" cols="12" lg="3" sm="6">
                              <span> <strong>Examination ::</strong></span>
                          </v-col>
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      x-small
                                      fab
                                      outlined
                                      icon
                                      color="#0F2027"
                                      class="mr-2 mt-3"
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                    addnewlessonplan.type = 'examination';
                    dialog_add_new = true;
                  "
                                  >
                                      <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                              </template>
                              <span> Add new examination !!! </span>
                          </v-tooltip>
                          <v-col class="p-none" cols="12" lg="6" sm="5">
                              <v-text-field v-model="exammination_edit" color="#0F2027" rounded dense label="Examination" :readonly="!exammination_flag" placeholder="Examination" outlined></v-text-field>
                          </v-col>
                          <v-col class="p-none" cols="12" lg="2" sm="2">
                              <v-btn
                                  v-if="exammination_edit != null"
                                  class="button"
                                  x-small
                                  @click="
                  save_edit_item(
                    edit_course_plan_id,
                    exammination_edit,
                    exammination_index,
                    (type = 'examination')
                  )
                "
                              >
                                  <v-icon>mdi-plus</v-icon>
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-row>
                  <v-row dense justify="center" v-for="(examination, index) in examination_list" :key="index">
                      <v-col sm="5">
                          <v-row dense>
                              <v-btn
                                  x-small
                                  fab
                                  icon
                                  outlined
                                  color="#0F2027"
                                  @click="
                  editunit(
                    examination.examination,
                    index,
                    (type = 'examination')
                  );
                  exammination_flag = true;
                "
                              >
                                  <v-icon x-small color="#0F2027" title="edit">edit</v-icon>
                              </v-btn>
                              <v-btn
                                  x-small
                                  fab
                                  outlined
                                  icon
                                  color="error"
                                  class="btn1"
                                  @click="
                  deletelistvalue(
                    index,
                    (type = 'examination'),
                    edit_course_plan_id
                  )
                "
                              >
                                  <v-icon x-small color="error" title="delete">delete</v-icon>
                              </v-btn>
                              <span class="ml-4 pt-1">{{ index + 1 }}.{{ examination.examination }}</span>
                          </v-row>
                      </v-col>
                  </v-row>
              </v-col>
          </v-card>

          <!-- Edit Lesson Plan end-->

          <v-card class="box" v-if="plan == true">
              <v-toolbar flat dense>
                  <v-toolbar-title>
                      <strong> Lesson Planning </strong>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>

                  <!-- excel btn code -->
                  <v-col cols="12" sm="2" md="2">
                      <v-btn color="success" outlined rounded v-if="plan_list.length != 0">
                          <download-excel class="mr-2 pb-3 pt-2" :data="plan_list" :fields="table_fields" worksheet="LessonPlanning" name="LessonPlanning.xls"> <v-icon dark>mdi-file-excel</v-icon> Export </download-excel>
                      </v-btn>
                  </v-col>

                  <!-- excel btrn code end -->
                  <v-text-field class="pt-2" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                  <v-btn class="button" @click="addnew">Add New Lesson Plan</v-btn>
              </v-toolbar>
              <v-data-table v-if="plan_list.length > 0 && plan == true" dense :headers="headers" :search="search" :items="plan_list" class="elevation-1 mytable">
                  <template v-slot:item.action="{ item }">
                      <v-row>
                          <v-btn x-small fab icon outlined color="#0F2027">
                              <v-icon x-small color="#0F2027" @click="editItem(item.cp_id)" title="edit">edit</v-icon>
                          </v-btn>
                          <v-btn x-small fab outlined icon color="error" class="btn">
                              <v-icon x-small color="error" @click="deletedItem(item.cp_id)" title="edit">delete</v-icon>
                          </v-btn>
                      </v-row>
                  </template>
              </v-data-table>
          </v-card>
      </v-card>
      <v-dialog v-model="dialog_delete" persistent max-width="600px">
          <v-card>
              <v-container>
                  <v-card class="box">
                      <v-row dense justify="center">
                          <strong>Are you sure you want Delete ???</strong>
                      </v-row>
                      <v-row dense justify="center">
                          <v-btn class="button" outlined @click="dialog_delete = false">No</v-btn>
                          <v-btn
                              class="button"
                              outlined
                              @click="
                deletelistvalue_yes(
                  delete_index,
                  delete_type,
                  edit_course_plan_id
                )
              "
                          >
                              Yes
                          </v-btn>
                      </v-row>
                  </v-card>
              </v-container>
          </v-card>
      </v-dialog>
      <v-dialog v-model="dialog_delete1" persistent max-width="600px">
          <v-card>
              <v-container>
                  <v-card class="box">
                      <v-row dense justify="center">
                          <strong>Are you sure you want Delete ???</strong>
                      </v-row>
                      <v-row dense justify="center">
                          <v-btn class="button" outlined @click="dialog_delete1 = false">No</v-btn>
                          <v-btn class="button" outlined @click="deleteplan(edit_course_plan_id)">Yes</v-btn>
                      </v-row>
                  </v-card>
              </v-container>
          </v-card>
      </v-dialog>
      <v-dialog v-model="dialog_add_new" persistent max-width="900px">
          <v-card>
              <v-container>
                  <v-card class="box">
                      <v-row dense justify="center" v-if="addnewlessonplan.type == 'unit'">
                          <v-col class="v-col" sm="6">
                              <v-text-field v-model="addnewlessonplan.unit" color="#0F2027" rounded dense label="Add New Chapter" placeholder="Add New Chapter" outlined></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row dense justify="center" v-if="addnewlessonplan.type == 'topic'">
                          <v-col class="v-col" sm="6">
                              <v-text-field v-model="addnewlessonplan.topic" color="#0F2027" rounded dense label=" Add New Concept Skill / Topic" placeholder="Add New Concept Skill / Topic" outlined></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row dense justify="center" v-if="addnewlessonplan.type == 'outcome'">
                          <v-col class="v-col" sm="6">
                              <v-text-field v-model="addnewlessonplan.outcome" color="#0F2027" rounded dense label="Add New Learning Outcomes" placeholder="Add New Learning Outcomes" outlined></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row dense justify="center" v-if="addnewlessonplan.type == 'tool'">
                          <v-col class="v-col" sm="6">
                              <v-text-field v-model="addnewlessonplan.tools" color="#0F2027" rounded dense label="Add New Instructional Tools & References" placeholder="Add New Instructional Tools & References" outlined></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row dense justify="center" v-if="addnewlessonplan.type == 'pedagogy'">
                          <v-col class="v-col" sm="6">
                              <v-text-field v-model="addnewlessonplan.pedagogy" color="#0F2027" rounded dense label="Add New Pedagogy" placeholder="Add New Pedagogy" outlined></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row dense justify="center" v-if="addnewlessonplan.type == 'assignment'">
                          <v-col class="v-col" sm="6">
                              <v-text-field
                                  v-model="addnewlessonplan.assignment"
                                  color="#0F2027"
                                  rounded
                                  dense
                                  label="Add New Activity / Assignment / Research"
                                  placeholder="Add New Activity / Assignment / Research"
                                  outlined
                              ></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row dense justify="center" v-if="addnewlessonplan.type == 'assessment'">
                          <v-col class="v-col" sm="6">
                              <v-text-field v-model="addnewlessonplan.assessment" color="#0F2027" rounded dense label="Add New Assessment" placeholder="Add New Assessment" outlined></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row dense justify="center" v-if="addnewlessonplan.type == 'examination'">
                          <v-col class="v-col" sm="6">
                              <v-text-field v-model="addnewlessonplan.exammination" color="#0F2027" rounded dense label="Add New Examination" placeholder="Add New Examination" outlined></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row dense justify="center">
                          <v-btn class="button" outlined @click="dialog_add_new = false">Cancel</v-btn>
                          <v-btn
                              class="button"
                              outlined
                              @click="
                addnewLessonPlanData(
                  edit_course_plan_id,
                  addnewlessonplan.type
                )
              "
                          >
                              Save
                          </v-btn>
                      </v-row>
                  </v-card>
              </v-container>
          </v-card>
      </v-dialog>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Lesson Planning Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/2AnofIWgp_A?si=GtYtP6GrcKQ8cnX4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
      data() {
          return {
              snackbar_msg: "",
              videoDialog: false,
              color: "",
              snackbar: false,
              search: null,
              ay_std_div_list: null,
              sel_ay_data: null,
              show_tt: false,
              std_div_list: null,
              sel_std_data: null,
              div_list: null,
              div: null,
              overlay: false,
              crs_list: null,
              crs: null,
              lesson_no_edit: "",
              lesson_no: 1,
              unit: null,
              topic: null,
              outcome: null,
              tools: null,
              pedagogy: null,
              assignment: null,
              assessment: null,
              exammination: null,
              plan: false,
              add_new: false,
              edit_new: false,
              plan_list: [],
              dialog_delete: false,
              headers: [
                  { text: "Sr. No.", value: "sr_no" },
                  { text: "Lesson No", value: "lecture_no" },
                  { text: "Chapter", value: "unit" },
                  { text: "Concept & Skills / Topic", value: "topic" },
                  { text: "Learning Outcomes", value: "learning_outcomes" },
                  {
                      text: "Instructional Tools & Reference",
                      value: "instructional_tool_refernences",
                  },
                  { text: "Pedagogy", value: "pedagogy" },
                  {
                      text: " Activity / Assignment / Research",
                      value: "activity_assignment_research",
                  },
                  { text: "Assessment", value: "assessment" },
                  { text: "Examination", value: "exam_name" },
                  { text: "Actions", value: "action", sortable: false },
              ],
              table_fields: {
                  "Sr. No": "sr_no",
                  "Lesson No": "lecture_no",
                  Chapter: "unit",
                  "Concept & Skills / Topic": "topic",
                  "Learning Outcomes": "learning_outcomes",
                  "Instructional Tools & Reference": "instructional_tool_refernences",
                  Pedagogy: "pedagogy",
                  "Activity / Assignment / Research": "activity_assignment_research",
                  Assessment: "assessment",
                  Examination: "exam_name",
              },
              unit_list: null,
              edit_unit: null,
              topic_list: null,
              edit_topic: null,
              outcome_list: null,
              edit_outcome: null,
              tool_list: null,
              edit_tool: null,
              pedagogy_list: null,
              edit_pedagogy: null,
              assignment_list: null,
              edit_assignment: null,
              assessment_list: null,
              assessment_edit: null,
              examination_list: null,
              exammination_edit: null,
              edit_course_plan_id: null,
              unit_index: null,
              topic_index: null,
              tool_index: null,
              outcome_index: null,
              pedagogy_index: null,
              assignment_index: null,
              aassessment_index: null,
              exammination_index: null,
              delete_index: null,
              delete_type: null,
              dialog_delete1: false,
              unit_flag: false,
              topic_flag: false,
              tool_flag: false,
              outcome_flag: false,
              pedagogy_flag: false,
              assignment_flag: false,
              aassessment_flag: false,
              exammination_flag: false,
              dialog_add_new: false,
              add_new_list: [],
              addnewlessonplan: {
                  type: null,
                  unit: null,
                  topic: null,
                  outcome: null,
                  tools: null,
                  pedagogy: null,
                  assignment: null,
                  assessment: null,
                  exammination: null,
              },
          };
      },
      methods: {
          updateLessonNo() {},
          addnewLessonPlanData(edit_course_plan_id, type) {
              // alert(edit_course_plan_id);
              // alert(type);
              var added_value;
              if (type == "unit") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.unit);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { unit: this.addnewlessonplan.unit };
                  added_value = this.add_new_list;
              }
              if (type == "topic") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.topic);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { topic: this.addnewlessonplan.topic };
                  added_value = this.add_new_list;
              }
              if (type == "tool") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.tools);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { tool: this.addnewlessonplan.tools };
                  added_value = this.add_new_list;
              }
              if (type == "outcome") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.outcome);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { outcome: this.addnewlessonplan.outcome };
                  added_value = this.add_new_list;
              }
              if (type == "pedagogy") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.pedagogy);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { pedagogy: this.addnewlessonplan.pedagogy };
                  added_value = this.add_new_list;
              }
              if (type == "assignment") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.assignment);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { assignment: this.addnewlessonplan.assignment };
                  added_value = this.add_new_list;
              }
              if (type == "assessment") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.assessment);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { assessment: this.addnewlessonplan.assessment };
                  added_value = this.add_new_list;
              }
              if (type == "examination") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.exammination);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = {
                      exammination: this.addnewlessonplan.exammination,
                  };
                  added_value = this.add_new_list;
              }
              // alert(added_value)
              const formData = {
                  edit_course_plan_id: edit_course_plan_id,
                  added_value: added_value,
                  type: type,
              };
              axios
                  .post("/LessonPlanning/save_add_new_plan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Added Successfully!!!"); // show snackbar on success
                          this.editItem(edit_course_plan_id);
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.dialog_add_new = false;
                      (this.addnewlessonplan.type = null),
                          (this.addnewlessonplan.unit = null),
                          (this.addnewlessonplan.topic = null),
                          (this.addnewlessonplan.outcome = null),
                          (this.addnewlessonplan.tools = null),
                          (this.addnewlessonplan.pedagogy = null),
                          (this.addnewlessonplan.assignment = null),
                          (this.addnewlessonplan.assessment = null),
                          (this.addnewlessonplan.exammination = null);
                  });
          },
          deletelistvalue(index, type, edit_course_plan_id) {
              this.delete_index = index;
              this.delete_type = type;
              this.edit_course_plan_id = edit_course_plan_id;
              this.dialog_delete = true;
          },
          deletelistvalue_yes(index, type, edit_course_plan_id) {
              var list;
              if (type == "unit") {
                  this.unit_list.splice(index, 1);
                  //console.log(this.unit_list)
                  list = this.unit_list;
              }
              if (type == "topic") {
                  this.topic_list.splice(index, 1);
                  list = this.topic_list;
              }
              if (type == "tool") {
                  this.tool_list.splice(index, 1);
                  list = this.tool_list;
              }
              if (type == "outcome") {
                  this.outcome_list.splice(index, 1);
                  list = this.outcome_list;
              }
              if (type == "pedagogy") {
                  this.pedagogy_list.splice(index, 1);
                  list = this.pedagogy_list;
              }
              if (type == "assignment") {
                  this.assignment_list.splice(index, 1);
                  list = this.assignment_list;
              }
              if (type == "assessment") {
                  this.assessment_list.splice(index, 1);
                  list = this.assessment_list;
              }
              if (type == "examination") {
                  this.examination_list.splice(index, 1);
                  list = this.examination_list;
              }
              const formData = {
                  edit_course_plan_id: edit_course_plan_id,
                  edited_unit: list,
                  type: type,
              };
              axios
                  .post("/LessonPlanning/save_edit_plan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning Deleted Successfully!!!"); // show snackbar on success
                          this.editItem(edit_course_plan_id);
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.dialog_delete = false;
                  });
          },
          save_edit_item(edit_course_plan_id, value, index, type) {
              var edited_value;
              const isAllWhiteSpace = /^\s+$/.test(value);
              if (isAllWhiteSpace) {
                  this.showSnackbar("error", "Please add data !!!");
                  return;
              }
              if (type == "unit") {
                  this.unit_list[index] = { unit: value };
                  edited_value = this.unit_list;
              }
              if (type == "topic") {
                  this.topic_list[index] = { topic: value };
                  edited_value = this.topic_list;
              }
              if (type == "tool") {
                  this.tool_list[index] = { tool: value };
                  edited_value = this.tool_list;
              }
              if (type == "outcome") {
                  this.outcome_list[index] = { outcome: value };
                  edited_value = this.outcome_list;
              }
              if (type == "pedagogy") {
                  this.pedagogy_list[index] = { pedagogy: value };
                  edited_value = this.pedagogy_list;
              }
              if (type == "assignment") {
                  this.assignment_list[index] = { assignment: value };
                  edited_value = this.assignment_list;
              }
              if (type == "assessment") {
                  this.assessment_list[index] = { assessment: value };
                  edited_value = this.assessment_list;
              }
              if (type == "examination") {
                  this.examination_list[index] = { examination: value };
                  edited_value = this.examination_list;
              }
              const formData = {
                  edit_course_plan_id: edit_course_plan_id,
                  edited_unit: edited_value,
                  type: type,
              };
              axios
                  .post("/LessonPlanning/save_edit_plan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning Updated Successfully!!!"); // show snackbar on success
                          this.editItem(edit_course_plan_id);
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.edit_unit = null;
                      this.edit_topic = null;
                      this.edit_outcome = null;
                      this.edit_tool = null;
                      this.edit_pedagogy = null;
                      this.edit_assignment = null;
                      this.assessment_edit = null;
                      this.exammination_edit = null;
                  });
          },
          editunit(value, index, type) {
              //alert(index)
              if (type == "unit") {
                  this.edit_unit = value;
                  this.unit_index = index;
              }
              if (type == "topic") {
                  this.edit_topic = value;
                  this.topic_index = index;
              }
              if (type == "tool") {
                  this.edit_tool = value;
                  this.tool_index = index;
              }
              if (type == "outcome") {
                  this.edit_outcome = value;
                  this.outcome_index = index;
              }
              if (type == "pedagogy") {
                  this.edit_pedagogy = value;
                  this.pedagogy_index = index;
              }
              if (type == "assignment") {
                  this.edit_assignment = value;
                  this.assignment_index = index;
              }
              if (type == "assessment") {
                  this.assessment_edit = value;
                  this.aassessment_index = index;
              }
              if (type == "examination") {
                  this.exammination_edit = value;
                  this.exammination_index = index;
              }
          },
          addnew() {
              (this.add_new = true), (this.edit_new = false);
          },
          deletedItem(cp_id) {
              this.edit_course_plan_id = cp_id;
              this.dialog_delete1 = true;
          },
          deleteplan(cp_id) {
              const formData = {
                  cp_id: cp_id,
              };
              axios
                  .post("/LessonPlanning/save_delete_plan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning Deleted Successfully!!!"); // show snackbar on succes
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.dialog_delete1 = false;
                  });
          },
          editItem(cp_id) {
              (this.add_new = false), (this.edit_new = true);
              const formData = {
                  cp_id: cp_id,
              };
              axios
                  .post("/LessonPlanning/editLessonPlan", formData)
                  .then((res) => {
                      this.unit_list = res.data.unit_list;
                      this.topic_list = res.data.topic_list;
                      this.outcome_list = res.data.outcome_list;
                      this.tool_list = res.data.tool_list;
                      this.pedagogy_list = res.data.pedagogy_list;
                      this.assignment_list = res.data.assignment_list;
                      this.assessment_list = res.data.assessment_list;
                      this.examination_list = res.data.examination_list;
                      this.edit_course_plan_id = res.data.cp_id;
                      this.lesson_no_edit = res.data.lesson_no;
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                  });
          },
          getLessonPlan() {
              this.plan = true;
              this.edit_new = false;
              const formData = {
                  standard: this.sel_std_data.std_id,
                  crs: this.crs,
              };
              axios
                  .post("/LessonPlanning/getLessonPlan", formData)
                  .then((res) => {
                      this.plan_list = res.data.plan_list;
                      this.lesson_no = res.data.lesson_plan;
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                  });
          },
          getStd() {
              this.std_div_list = null;
              this.sel_std_data = null;
              this.div_list = null;
              this.div = null;
              this.std_div_list = this.sel_ay_data.std_list;
          },
          getCourse() {
              const formData = {
                  standard: this.sel_std_data.std_id,
                  ay: this.sel_ay_data.ay_id,
              };
              axios
                  .post("/LessonPlanning/getCourse", formData)
                  .then((res) => {
                      this.crs_list = res.data.crs_list;
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                  });
          },

          saveLessonPlan() {
              const formData = {
                  standard: this.sel_std_data.std_id,
                  crs: this.crs,
                  lesson_no: this.lesson_no,
                  unit: this.unit,
                  topic: this.topic,
                  outcome: this.outcome,
                  tools: this.tools,
                  pedagogy: this.pedagogy,
                  assignment: this.assignment,
                  assessment: this.assessment,
                  exammination: this.exammination,
              };
              axios
                  .post("/LessonPlanning/saveLessonPlan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning Added Successfully!!!"); // show snackbar on success
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      (this.unit = null), (this.topic = null), (this.outcome = null), (this.tools = null), (this.pedagogy = null), (this.assignment = null), (this.assessment = null), (this.exammination = null);
                      this.add_new = false;
                  });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          onload() {
              axios
                  .post("/commonAPI/get_ay_std_div")
                  .then((res) => {
                      this.ay_std_div_list = res.data.data;
                      this.sel_ay_data = res.data.curr_ay;
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  })
                  .finally(() => {});
          },
      },
      mounted() {
          this.onload();
      },
  };
</script>
<style scoped>
  .v-col {
      padding: 0rem !important;
      margin: 0rem !important;
  }

  .btn {
      margin-left: 2%;
  }
  .btn1 {
      margin-left: 0.5rem;
  }
</style>
